var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_452",
    "data-name": "Group 452",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.64,
    height: 32.638,
    viewBox: "0 0 32.64 32.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 32.639,
    height: 3.551,
    transform: "translate(3.524 26.603) rotate(-45)",
    fill: "#f3f1e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 3.551,
    height: 32.639,
    transform: "translate(3.524 6.035) rotate(-45)",
    fill: "#f3f1e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 3.551,
    height: 32.638,
    transform: "translate(14.545)",
    fill: "#f3f1e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 32.64,
    height: 3.551,
    transform: "translate(0 14.542)",
    fill: "#f3f1e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.aa270de144938e9557fb811a9a73a78d.svg";
export { ForwardRef as ReactComponent };